import { FC, ReactNode, ReactElement } from 'react'
import { useRouter } from 'next/router'
import NextLink, { LinkProps } from 'next/link'
import NoSSR from 'react-no-ssr'
import { useBackNavigation } from '@hooks'

/**
 * Smart ass that returns the link wrapper if the link prop is set // Josep Vidal comment
 * @returns {JSX.Element|{children: *}}
 * @constructor
 */
const WithOrWithoutLink: FC<IWithOrWithoutLink> = ({
  nextJSLinkProps = { href: '' },
  children,
  backLinkStored = null,
  title
}): ReactElement<any, any> => {
  const { get, keys } = useBackNavigation()
  const router = useRouter()

  // exception when coming from SEARCH to OVR artwork
  if (
    router?.asPath?.includes('catalog/artwork') &&
    get(keys.OVR_INTRO.INSIDE_ARTWORK) &&
    get(keys.OVR_INTRO.INSIDE_ARTWORK)?.includes('/search')
  ) {
    return <a title={title || ''} href={get(keys.OVR_INTRO.INSIDE_ARTWORK) || ''}>{children}</a>
  }

  // exception when coming from artwork recommendations
  if (
    router?.asPath?.includes('catalog/artwork') &&
    router?.asPath?.includes('comingFromRecommendation')
  ) {
    if (get(keys.OVR_INTRO.INSIDE_ARTWORK_RECOMMENDATION)?.includes('comingFromRecommendation')) {
      return <a title={title || ''} href={get(keys.OVR_INTRO.INSIDE_ARTWORK) || ''}>{children}</a>
    } else {
      return <a title={title || ''} href={get(keys.OVR_INTRO.INSIDE_ARTWORK_RECOMMENDATION) || ''}>{children}</a>
    }
  }

  // This exception is when previewing the OVR from the EVEU
  if (router?.asPath?.includes('detail') && backLinkStored?.includes('detail')) {
    return <a title={title || ''} href={backLinkStored}>{children}</a>
  }

  if (!nextJSLinkProps?.href) {
    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
    return <a title={title || ''}>{children}</a>
  }

  return (
    <NoSSR>
      <NextLink {...nextJSLinkProps} legacyBehavior>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a title={title || ''}>{children}</a>
      </NextLink>
    </NoSSR>
  )
}

interface IWithOrWithoutLink {
  nextJSLinkProps?: LinkProps
  children: ReactNode
  backLinkStored?: string | null
  title?: string
}

export default WithOrWithoutLink
